import { render, staticRenderFns } from "./u-inline-group.vue?vue&type=template&id=4cb818b0&scoped=true&"
import script from "./u-inline-group.vue?vue&type=script&lang=js&"
export * from "./u-inline-group.vue?vue&type=script&lang=js&"
import style0 from "./u-inline-group.vue?vue&type=style&index=0&id=4cb818b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb818b0",
  null
  
)

export default component.exports